import { TransactionsDetailsItemFromServer } from './types'
import { getFinsystemNumberFormat } from '../../../../../libs/utils'

export const getTransactionItems = (
  transactions: TransactionsDetailsItemFromServer[],
) => {
  return transactions?.map((item) => {
    const amountValue =
      item.direction === 'In' && item.type == 'Budget payment'
        ? -Math.abs(Number(item.amount))
        : item.amount
    const amountUsdValue =
      item.direction === 'In' && item.type == 'Budget payment'
        ? -Math.abs(Number(item.amountUsd))
        : item.amountUsd

    return {
      ...item,
      amount: `${getFinsystemNumberFormat(amountValue, 8)} ${item.currency}`,
      amountUsd: `${getFinsystemNumberFormat(amountUsdValue, 8)}`,
      ourCommission: `${getFinsystemNumberFormat(item.ourCommission, 8)} ${
        item.ourCommissionCurrency
      }`,
      psCommission: `${getFinsystemNumberFormat(item.psCommission, 8)} ${
        item.psCommissionCurrency
      }`,
      clientAmount: `${getFinsystemNumberFormat(item.clientAmount, 8)} ${
        item.clientCurrency
      }`,
      exchangeRate: `${getFinsystemNumberFormat(item.exchangeRate, 8)}`,
    }
  })
}
